import { moment } from '../../util/date'

/**
 * @param {Date|string|object|null} value
 * @param {string|null}             [locale]
 * @return {MomentRange}
 */
export function toMomentRange(value, locale) {
    if (!value) {
        return createEmptyRange(locale)
    } else if (typeof value === 'object' && 'start' in value && 'end' in value) {
        return createMomentRange(value.start, value.end, locale)
    } else {
        // Single day - Create range from `value` to `value`
        return createMomentRange(value, value, locale)
    }
}

function createEmptyRange(locale = null) {
    return createMomentRange(null, null, locale)
}

export function toMoment(value, locale) {
    const momentInstance = value instanceof moment ? value : moment(value)

    if (locale) {
        momentInstance.locale(locale)
    }
    return momentInstance
}

function createMomentRange(start, end, locale) {
    if (locale) {
        start = start ? moment(start).locale(locale) : start
        end = end ? moment(end).locale(locale) : end
        return moment.range(start, end)
    } else {
        return moment.range(start, end)
    }
}
